import { Empty } from "antd";
import KoboConverter from "Components/KoboConverter";
import Loader from "Components/Loader";
import Scaffold from "Components/Scaffold";
import { Separator } from "Components/Separator";
import { useGetTopSalesQuery } from "hooks/Dashboard/useGetTopSalesQuery";

const TopSellingProducts = ({ timePeriod }: { timePeriod: string }) => {
  const { data: topSales, isLoading } = useGetTopSalesQuery({
    timePeriod: timePeriod,
  });

  const TopItemsList = () => {
    const isEmpty = topSales?.data.length === 0;

    if (isLoading) {
      return <Loader />;
    }
    if (isEmpty) {
      return (
        <div className="h-full grid place-content-center">
          <Empty description="No data available" className="my-[20px]" />
        </div>
      );
    }

    return (
      <div className="flex flex-col">
        {topSales?.data.map((item: any, index: any) => (
          <div key={index}>
            <div className="flex gap-2 px-5 py-3 items-center">
              <div className="w-1/12">{index + 1}</div>
              <div className="w-5/12 flex gap-[5px] items-center">
                <img
                  src={item?.productImage}
                  alt=""
                  className="h-[30px] w-[30px]"
                />
                {item?.productName}
              </div>
              <div className="w-3/12 ml-2">
                {item?.totalUnitsSold.toLocaleString()}
              </div>
              <div className="w-3/12">
                <KoboConverter amount={item?.totalRevenue} />
              </div>
            </div>
            {index !== topSales?.data.length - 1 && <Separator />}
          </div>
        ))}
      </div>
    );
  };

  return (
    <Scaffold
      left={`Top Selling Products`}
      className="p-0 h-[280px] overflow-scroll text-[12px]"
    >
      <div className="flex gap-2 px-5 py-3 text-ash font-medium">
        <div className="w-1/12">no.</div>
        <div className="w-5/12">Product</div>
        <div className="w-3/12 ml-2">Quantity Sold</div>
        <div className="w-3/12">Amount</div>
      </div>
      <Separator />
      <div className="">{<TopItemsList />}</div>
    </Scaffold>
  );
};

export default TopSellingProducts;
